import { Navigate, Route, Routes, useLocation } from 'react-router';
import { RedirectIfAuthenticated, RequireAdmin, RequireOwner } from './auth-guard';
import { AdminLayout } from './layout/AdminLayout';
import { AcessoPage } from './pages/AcessoPage';
import { PessoaPage } from './pages/pessoas/PessoaPage';
import { PessoasPage } from './pages/pessoas/PessoasPage';
import { CadastroAssistidoPage } from './pages/CadastroAssistidoPage';
import { ComentarioAssistidoPage } from './pages/comentario/ComentarioAssistidoPage';
import { CadastrosPage } from './pages/CadastrosPage';
import { AcervoPage } from './pages/AcervoPage';
import { ArtigosComentadosPage } from './pages/legislacao/ArtigosComentadosPage';
import { LeiPage } from './pages/legislacao/LeiPage';
import { TrilhaPage } from './pages/TrilhaPage';
import { ReportesPage } from './pages/ReportesPage';
import { ProgressoPage } from './pages/ProgressoPage';
import { NoticiasPage } from './pages/NoticiasPage';
import { MateriaisPage } from './pages/MateriaisPage';
import { RevistaPage } from './pages/RevistaPage';
import { LoginPage } from './pages/LoginPage';
import { AutorizarPage } from './pages/AutorizarPage';
import { ProdutoPage } from './pages/produtos/ProdutoPage';
import { ProdutosPage } from './pages/produtos/ProdutosPage';
import { ProvaFormPage } from './pages/provas/ProvaFormPage';
import { ProvasPage } from './pages/provas/ProvasPage';
import { QuestaoFormPage } from './pages/questoes/QuestaoFormPage';
import { QuestoesPage } from './pages/questoes/QuestoesPage';

/**
 * Rotas da administração. As telas de reports e configuração do Cadastro
 * Assistido entram nos PRs de domínio seguintes.
 */
export function App() {
  return (
    <Routes>
      <Route element={<RedirectIfAuthenticated />}>
        <Route path="/entrar" element={<LoginPage />} />
      </Route>

      {/* Fora do RedirectIfAuthenticated de propósito: quem já tem sessão
          precisa ver o pedido de autorização, e não ser mandado para a home. */}
      <Route path="/autorizar" element={<AutorizarPage />} />

      <Route element={<RequireAdmin />}>
        <Route element={<AdminLayout />}>
          <Route index element={<ProgressoPage />} />
          <Route path="/provas" element={<ProvasPage />} />
          <Route path="/provas/:id" element={<ProvaFormPage />} />
          <Route path="/questoes" element={<QuestoesPage />} />
          <Route path="/questoes/:id" element={<QuestaoFormPage />} />
          <Route path="/reportes" element={<ReportesPage />} />
          <Route path="/noticias" element={<NoticiasPage />} />
          <Route path="/revista" element={<RevistaPage />} />
          <Route path="/materiais" element={<MateriaisPage />} />
          <Route path="/cadastro-assistido" element={<CadastroAssistidoPage />} />
          <Route path="/comentario-assistido" element={<ComentarioAssistidoPage />} />
          <Route path="/legislacao" element={<ArtigosComentadosPage />} />
          <Route path="/legislacao/leis/:id" element={<LeiPage />} />
          {/*
           * Havia aqui a geração anterior, de PDF rasterizado, em
           * `/legislacao-pdf`. Ela saiu em 07/09/2026, com o material que
           * mostrava: o Calebe decidiu aposentá-la no checkpoint da
           * produtização das legislações.
           */}
          <Route path="/acervo" element={<AcervoPage />} />
          <Route path="/trilha" element={<TrilhaPage />} />
          <Route path="/cadastros" element={<CadastrosPage />} />
          <Route path="/acesso" element={<AcessoPage />} />

          {/*
            O que é do Dono, atrás de um portão próprio. As rotas da API já
            recusam os demais papéis (G-POLICY); o guarda existe para a tela não
            abrir e encher de erro no lugar de dizer o motivo.
          */}
          <Route element={<RequireOwner />}>
            <Route path="/produtos" element={<ProdutosPage />} />
            <Route path="/produtos/:id" element={<ProdutoPage />} />
            {/*
             * Pessoas reúne o que eram `/assinantes`, `/origem` e
             * `/administradores`, telas separadas até 18/09/2026. As três liam a
             * mesma população por eixos diferentes e nenhuma delas abria **uma**
             * pessoa - que passou a ser a pergunta do dia quando o GTM começou.
             * `/listas` veio em 25/09/2026, e o endereço antigo leva à aba.
             */}
            <Route path="/pessoas" element={<PessoasPage />} />
            <Route path="/pessoas/:id" element={<PessoaPage />} />
            <Route path="/listas" element={<ListasQueViraramAba />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

/**
 * `/listas` foi tela própria até 25/09/2026, quando virou aba de Pessoas. O
 * link salvo cai na aba, com o tópico e a página que carregava - e não na
 * seção sem recorte, nem numa tela em branco.
 */
function ListasQueViraramAba() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('aba', 'listas');
  return <Navigate to={`/pessoas?${params.toString()}`} replace />;
}
